export interface FeatureFlag {
  key: string;
  enabled: boolean;
  rolloutPercentage?: number;
  targetRoles?: string[];
  allowList?: string[]; // User IDs
  denyList?: string[]; // User IDs
  startDate?: Date;
  endDate?: Date;
  reason?: string;
}

export interface GlobalFeatureFlags {
  emergency: Record<string, boolean>; // Emergency toggles override everything
  defaults: Record<string, FeatureFlag>;
}

export interface ExperimentConfig {
  key: string;
  enabled: boolean;
  rolloutPercentage: number;
  targetRoles?: string[];
  variants?: Record<string, number>; // variant -> percentage
}

export interface FeatureToggleResult {
  enabled: boolean;
  reason?: string;
  variant?: string;
  source: FeatureToggleSource;
}

export enum FeatureToggleSource {
  Emergency = "emergency",
  Global = "global",
  Tenant = "tenant",
  Role = "role",
  User = "user",
  Experiment = "experiment",
}
